<main class="d-flex-row flex-wrap main">
  <div class="success-container">
    <div class="success-card">
      <div class="success-disclaimer" 
      *ngIf="(this.paymentMethod === this.paymentMethodEnum.CREDIT_CARD) || (this.paymentMethod === this.paymentMethodEnum.BANK_BILLET) || this.isPixPaid">
        <div><img src="../../../assets/images/success.svg"/></div>
        <div class="success-disclaimer-text" *ngIf="paymentMethod === paymentMethodEnum.CREDIT_CARD || this.isPixPaid">
          <p class="order-text">Pedido {{this.checkoutSuccessData.contract.code}}</p>
          <p class="success-text">Pedido efetuado com sucesso!</p>
        </div>
        <div class="success-disclaimer-text" *ngIf="paymentMethod === paymentMethodEnum.BANK_BILLET">
          <p class="success-text">Estamos quase lá</p>
          <p class="order-text-bank-billet">O seu {{this.checkoutSuccessData.contract.product.name}} será ativado <strong>logo após a confirmação do pagamento.</strong></p>
          <p>Copia e cola:</p>
          <div class="data-bar-code">
              <mat-card>
                  <mat-card-content>
                      <b>{{this.checkoutSuccessData.bankBilletData.barcode}}</b>
                      <img class="icon-copy" src="/assets/images/icon-copy.svg" matTooltip="Copiar código"
                          (click)="copyContent()">
                  </mat-card-content>
              </mat-card>
          </div>
          <p class="order-text-bank-billet">O prazo de compensação do boleto é de até <strong>3 dias úteis após o pagamento.</strong></p>
          <button class="pme-btn-lg btn-success" 
            (click)="openBankBilletOnNewTab(this.checkoutSuccessData.bankBilletData.bankBilletURL)">
            Baixar boleto
          </button>
        </div>
      </div>
      <div class="d-flex-column align-center" *ngIf="(this.paymentMethod === this.paymentMethodEnum.CREDIT_CARD) || (this.paymentMethod === this.paymentMethodEnum.BANK_BILLET) || this.isPixPaid">
        <div class="messages-container">
          <div class="messages">
              <img src="../../../assets/images/purple-email.svg">
              <p>Enviamos um e-mail para <b>seus dados e criar sua senha de acesso.</b></p>
          </div>
          <div class="messages">
              <img src="../../../assets/images/span-email-purple.svg" alt="">
              <p>Dica: se você não encontrar o nosso e-mail, dê uma olhada em sua <b>caixa de spam e adicione nosso remetente como confiável.</b></p>
          </div>
          <div class="messages" *ngIf="this.paymentMethod === this.paymentMethodEnum.BANK_BILLET">
            <img src="../../../assets/images/barcode-off.svg" alt="">
            <p><strong>O boleto venceu?</strong> Não tem problema. É só realizar uma nova compra.</p>
          </div>
          <div class="messages">
              <img src="../../../assets/images/note.svg">
              <p>Atenção! Sua nota fiscal será enviada dentro de <b>3 dias úteis.</b></p>
          </div>
        </div>
        <div class="call-center">
          <p><b>Central de atendimento</b></p>
          <div class="whats">
              <img src="../../../assets/images/whats-logo.svg">
              <p>WhatsApp +55 (11) 3003.7372</p>
          </div>
        </div>
        <button class="btn-register" (click)="redirectSuccess()">Criar senha e fazer login</button>
      </div>
      <div *ngIf="this.paymentMethod === this.paymentMethodEnum.PIX && !this.isPixPaid">
        <pme-pix-success (msgIsPixPaid)="this.hasPixPaid($event)"></pme-pix-success>
      </div>
    </div>
  </div>
  <aside class="product-info-card">
    <pme-disconnected-sale-product 
            [productFamily]="this.productFamily" 
            [productName]="this.productName"
            [valuePerMonth]="this.valuePerMonth" 
            [totalValue]="this.totalValue"
            [productImg]="this.productImg"
            [installments]="this.installments"
            [firstStep]="true"
            [productValue]="this.productValue"
            [discountedValue]="this.discountedValue">
        </pme-disconnected-sale-product>
  </aside>
</main>
